var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "report-dashboard productivity-dashboard py-0",
      attrs: { fluid: "" }
    },
    [
      _c("DashboardFilters", { on: { input: _vm.setCriteria } }),
      _c("v-progress-linear", {
        attrs: { active: _vm.loading, color: "secondary", indeterminate: "" }
      }),
      _vm.dashboard
        ? _c(
            "div",
            {
              staticClass: "dashboard-content",
              style: { height: _vm.contentHeight }
            },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("labels.productiveVsNonProductive")) +
                    "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                _vm._l(_vm.productivityTiles, function(tile) {
                  return _c(
                    "v-col",
                    { key: tile.key, attrs: { cols: "12", sm: "4" } },
                    [
                      _c("DashboardTile", {
                        class: tile.key,
                        attrs: {
                          detail: tile.detail,
                          label: tile.label,
                          value: tile.value
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.productiveHoursPerDay")) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.productivityPerDayData,
                              options: _vm.stackedBarOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "chart-card non-productive-by-reason",
                          attrs: { outlined: "" }
                        },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.nonProductiveByReason")) +
                                "\n          "
                            )
                          ]),
                          _vm.nonProductiveByReasonData.labels.length > 0
                            ? _c("DoughnutChart", {
                                attrs: {
                                  "chart-data": _vm.nonProductiveByReasonData,
                                  options: _vm.doughnutOptions,
                                  styles: _vm.chartStyles
                                }
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "no-data grey--text",
                                  style: _vm.chartStyles
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.noRecords")) +
                                      "\n          "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c("div", { staticClass: "chart-title" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("labels.hoursBy")) +
                                    "\n            "
                                )
                              ]),
                              _c("v-spacer"),
                              _c(
                                "v-btn-toggle",
                                {
                                  staticClass: "breakdown",
                                  attrs: {
                                    color: "secondary",
                                    dense: "",
                                    mandatory: ""
                                  },
                                  model: {
                                    value: _vm.breakdown,
                                    callback: function($$v) {
                                      _vm.breakdown = $$v
                                    },
                                    expression: "breakdown"
                                  }
                                },
                                _vm._l(_vm.breakdownOptions, function(option) {
                                  return _c(
                                    "v-btn",
                                    {
                                      key: option.value,
                                      attrs: {
                                        small: "",
                                        text: "",
                                        value: option.value
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(option.text) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c("HorizontalBarChart", {
                            attrs: {
                              "chart-data": _vm.breakdownData,
                              options: _vm.horizontalStackedBarOptions,
                              styles: _vm.barChartStyles(
                                _vm.breakdownRows.length
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("labels.commitmentVsExpected")) +
                    "\n    "
                )
              ]),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                _vm._l(_vm.commitmentTiles, function(tile) {
                  return _c(
                    "v-col",
                    { key: tile.key, attrs: { cols: "12", sm: "4" } },
                    [
                      _c("DashboardTile", {
                        class: tile.key,
                        attrs: {
                          detail: tile.detail,
                          label: tile.label,
                          value: tile.value
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "labels.expectedVsCommittedByJobStatus"
                                  )
                                ) +
                                "\n          "
                            )
                          ]),
                          _c("BarChart", {
                            attrs: {
                              "chart-data": _vm.commitmentByJobStatusData,
                              options: _vm.groupedBarOptions,
                              styles: _vm.chartStyles
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "chart-card", attrs: { outlined: "" } },
                        [
                          _c("div", { staticClass: "chart-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("labels.commitmentByStaff")) +
                                "\n          "
                            )
                          ]),
                          _c("v-data-table", {
                            staticClass: "commitment-staff",
                            attrs: {
                              dense: "",
                              headers: _vm.staffHeaders,
                              "item-key": "userId",
                              items: _vm.staffRows,
                              "items-per-page": 10,
                              "no-data-text": _vm.$t(
                                "labels.noStaffWithWeeklyHours"
                              ),
                              "sort-by": "difference"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.weeklyHours",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatNumber(item.weeklyHours)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.expected",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatNumber(item.expected)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.committed",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatNumber(item.committed)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.difference",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            item.difference < 0
                                              ? "error--text"
                                              : ""
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                item.difference > 0 ? "+" : ""
                                              ) +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  item.difference
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "item.fulfillment",
                                  fn: function(ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatPercent(item.fulfillment)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3737129081
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }